import styled from 'styled-components';

import { space } from '../../tokens';

export const Spacer = styled.div<{ padding?: string }>`
  padding: ${(p) => p.padding ?? space[2]};
`;
